module.exports = __webpack_public_path__ + "img/327-7ef674.png";